export const REF_ID_LS_KEY = 'aurous_refId';
export const TOKEN_LS_KEY = 'aurous_token';
export const HIDE_EMPTY_SUB_LINES_LS_KEY = 'aurous_hideEmptySubLines';
